import React, { useState, useEffect } from "react";
import { putImputa as modifImputa } from "../helpers/rutaImputas";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import 'animate.css';

const ModalFormImputa = ({ imputa, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codimp: "",
    imputa: "",
  });

  useEffect(() => {
    if (imputa && imputa._id) {
      setFormValues({
        codimp: imputa.codimp || "",
        imputa: imputa.imputa || "",
      });
    }
  }, [imputa]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await modifImputa(imputa._id, formValues);
      console.log("✅ Imputación actualizada:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultar
        handleClose();         // Cerrar modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al actualizar imputación:", error);
      // Acá podrías mostrar un modal de error si lo necesitás
    }
  };


  // const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  // const [rutas, setRutas] = useState({ data: {}, loading: true });

  // useEffect(() => {
  //   getLocalidades().then((res) =>
  //     setLocalidades({ data: res, loading: false })
  //   );
  //   getRutas().then((res) => setRutas({ data: res, loading: false }));
  // }, []);

  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Imputación</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Imputación</label>
            <input
              type="text"
              className="form-control"
              name="imputa"
              required
              value={formValues.imputa}
              onChange={handleChange}
            />
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

     <Modal
       show={showSuccess}
       centered
       backdrop="static"
       keyboard={false}
       dialogClassName="animate__animated animate__fadeInDown"
     >
       <Modal.Body className="text-center">
         <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
       </Modal.Body>
    </Modal>
    </>
  );
};

export default ModalFormImputa;
